export function getFilenameFromContentDisposition(contentDisposition: string): string {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);

  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, '');
  }
  return 'download.pdf';
}
